// Add this inside the export default object below
export const rootPaths = {
  root: "/",
  dashboardRoot: "dashboard",

  authRoot: "auth",
  authCardRoot: "card",
  authSplitRoot: "split",

  olitaskRoot: "olitask",
  accountRoot: "account",
  generalRoot: "general",
  emailRoot: "emails",

  pagesRoot: "pages", // <-- changed from 'pages' to 'olitask'
  userRoot: "users", // add this if you use userRoot in userProfile path
  accessControlRoot: "access-control",

  monitoringRoot: "monitoring",
  healthRoot: "health-checks",
  financeRoot: "finance",
  featureDialRoot: "feature-dial",

  profileRoot: "profile"
};

export default {
    qaChecklist: `/${rootPaths.olitaskRoot}/qa-checklist`,
  analytics: `/${rootPaths.dashboardRoot}/analytics`,
  changelog: "/changelog",
  widgets: "/widgets",
  landing: "/landing",
  error404: `/${rootPaths.errorsRoot}/404`,
  error500: `/${rootPaths.errorsRoot}/500`,
  simpleLogin: `/${rootPaths.authRoot}/login`,
  simpleRegister: `/${rootPaths.authRoot}/register`,
  simpleLogout: `/${rootPaths.authRoot}/logout`,
  simpleForgotPassword: `/${rootPaths.authRoot}/forgot-password`,
  simpleVerificationCode: `/${rootPaths.authRoot}/verification-code`,
  simpleResetPassword: `/${rootPaths.authRoot}/reset-password`,
  simpleAccountRecoverySuccess: `/${rootPaths.authRoot}/account-recovery-success`,
  simpleSessionExpired: `/${rootPaths.authRoot}/session-expired`,
  splitForgotPassword: `/${rootPaths.authRoot}/${rootPaths.authSplitRoot}/forgot-password/verify`,
  splitResetPassword: `/${rootPaths.authRoot}/${rootPaths.authSplitRoot}/reset-password`,

  cardLogin: `/${rootPaths.authRoot}/${rootPaths.authCardRoot}/login`,
  cardRegister: `/${rootPaths.authRoot}/${rootPaths.authCardRoot}/register`,
  cardLogout: `/${rootPaths.authRoot}/${rootPaths.authCardRoot}/logout`,
  cardForgotPassword: `/${rootPaths.authRoot}/${rootPaths.authCardRoot}/forgot-password`,
  cardResetPassword: `/${rootPaths.authRoot}/${rootPaths.authCardRoot}/reset-password`,
  cardConfirmMail: `/${rootPaths.authRoot}/${rootPaths.authCardRoot}/confirm-mail`,
  cardLockScreen: `/${rootPaths.authRoot}/${rootPaths.authCardRoot}/lock-screen`,

  agreements: `/${rootPaths.generalRoot}/user-agreements`,
  agreementAdd: `/${rootPaths.generalRoot}/user-agreements/add`,
  agreementEdit: (id = ":id") =>
    `/${rootPaths.generalRoot}/user-agreements/${id}/edit`,
  agreementDetails: (id = ":id") =>
    `/${rootPaths.generalRoot}/user-agreements/${id}`,
  activeAgreement: `/${rootPaths.generalRoot}/active-agreement`,
  calendar: `/${rootPaths.generalRoot}/calendar`,
  chat: `/${rootPaths.generalRoot}/chat`,

  //account management paths
  securityQuestions: `/${rootPaths.accountRoot}/security-questions`,
  passwordReset: `/${rootPaths.accountRoot}/password-reset`,
  accountSecurityQns: `/${rootPaths.accountRoot}/account-security-questions`,
  createNewPassword: `/${rootPaths.accountRoot}/reset-password`,
  changePassword: `/${rootPaths.accountRoot}/change-password`,
  messageTemplates: `/${rootPaths.accountRoot}/message-templates`,
  messageTemplateDetails: (templateId) =>
    `/${rootPaths.accountRoot}/message-templates/${
      templateId ? `${templateId}` : ":templateId"
    }`,
  createMessageTemplate: `/${rootPaths.accountRoot}/message-templates/create`,
  editMessageTemplate: (templateId) =>
    `/${rootPaths.accountRoot}/message-templates/update/${
      templateId ? `${templateId}` : ":templateId"
    }`,
  notificationTopics: `/${rootPaths.accountRoot}/notification-topics`,

  // email paths
  emailSent: `/${rootPaths.generalRoot}/${rootPaths.emailRoot}/sent`,
  emailSentDetail: (emailId = ":emailId") =>
    `/${rootPaths.generalRoot}/${rootPaths.emailRoot}/sent/${emailId}`,
  emailCompose: `/${rootPaths.generalRoot}/${rootPaths.emailRoot}/compose`,
  emailIncoming: `/${rootPaths.generalRoot}/${rootPaths.emailRoot}/incoming`,
  emailOutgoing: `/${rootPaths.generalRoot}/${rootPaths.emailRoot}/outgoing`,
  emailAccounts: `/${rootPaths.generalRoot}/${rootPaths.emailRoot}/accounts`,
  emailInhouseCompose: `/${rootPaths.generalRoot}/${rootPaths.emailRoot}/compose-inhouse`,

  // health check paths
  healthChecks: `/${rootPaths.monitoringRoot}/${rootPaths.healthRoot}/view-all`,
  healthCheckAdd: `/${rootPaths.monitoringRoot}/${rootPaths.healthRoot}/add`,
  healthCheckDetail: (checkId = ":checkId") =>
    `/${rootPaths.monitoringRoot}/${rootPaths.healthRoot}/${checkId}`,
  healthCheckEdit: (checkId = ":checkId") =>
    `/${rootPaths.monitoringRoot}/${rootPaths.healthRoot}/edit/${checkId}`,

  // health check paths
  featureDial: `/${rootPaths.monitoringRoot}/${rootPaths.featureDialRoot}/view-all`,
  featureDialAdd: `/${rootPaths.monitoringRoot}/${rootPaths.featureDialRoot}/add`,
  featureDialDetail: (dialId = ":dialId") =>
    `/${rootPaths.monitoringRoot}/${rootPaths.featureDialRoot}/${dialId}`,
  featureDialEdit: (dialId = ":dialId") =>
    `/${rootPaths.monitoringRoot}/${rootPaths.featureDialRoot}/edit/${dialId}`,

  //user paths
  users: `/${rootPaths.olitaskRoot}/users`,
  helperProfiles: `/${rootPaths.olitaskRoot}/helper-profiles`,
  customers: `/${rootPaths.olitaskRoot}/users/customers`,
  staff: `/${rootPaths.olitaskRoot}/users/staff`,
  userEdit: (userId = ":userId") =>
    `/${rootPaths.olitaskRoot}/users/${userId}/edit`,
  userAdd: `/${rootPaths.olitaskRoot}/users/add`,
  userDetails: (userId = ":userId") =>
    `/${rootPaths.olitaskRoot}/users/${userId}`,
  userAffiliations: `/${rootPaths.olitaskRoot}/users/affiliations`,
  userDeletionRequests: `/${rootPaths.olitaskRoot}/users/deletion-requests`,
  identityDocuments: (userId = ":userId") =>
    `/${rootPaths.olitaskRoot}/users/${userId}/identity-documents`,
  userActionables: (userId = ":userId") =>
    `/${rootPaths.olitaskRoot}/users/${userId}/actionables`,
  userHelperProfile: (userId = ":userId") =>
    `/${rootPaths.olitaskRoot}/users/${userId}/helper-profile`,
  userProfile: `/${rootPaths.userRoot}/profile`,
  profileReviews: (role = ":role", userId = ":userId") =>
    `/${rootPaths.olitaskRoot}/reviews/profile/${role}/${userId}`,
  QRCodeGenerator: `/${rootPaths.olitaskRoot}/qrcode-generator`,
  airports: `/${rootPaths.olitaskRoot}/airports`,
  travelCategories: `/${rootPaths.olitaskRoot}/travel-categories`,
  meetingPoints: `/${rootPaths.olitaskRoot}/meeting-points`,
  helperRequests: `/${rootPaths.olitaskRoot}/helper-profiles`,
  helperProfessionProfiles: `/${rootPaths.olitaskRoot}/helper-professions`,
  helperProfessionBackgroundChecks: `/${rootPaths.olitaskRoot}/helper-professions/background-checks`,
  helperProfessionBackgroundCheckDetails: (backgroundCheckId = ":backgroundCheckId") =>
    `/${rootPaths.olitaskRoot}/helper-professions/background-checks/${backgroundCheckId}`,
  helperProfessionProfileDetails: (professionProfileId = ":professionProfileId") =>
    `/${rootPaths.olitaskRoot}/helper-professions/${professionProfileId}`,
  helperProfessionProfileCreateForHelper: (helperId = ":helperId") =>
    `/${rootPaths.olitaskRoot}/helpers/${helperId}/profession-profiles/new`,
  helperProfessionProfileEditForHelper: (
    helperId = ":helperId",
    professionProfileId = ":professionProfileId",
  ) =>
    `/${rootPaths.olitaskRoot}/helpers/${helperId}/profession-profiles/${professionProfileId}/edit`,

  // guest session paths
  guestSessions: `/${rootPaths.olitaskRoot}/users/guest-sessions`,

  //task paths
  tasks: `/${rootPaths.olitaskRoot}/tasks/all`,
  taskDetails: (taskId = ":taskId") =>
    `/${rootPaths.olitaskRoot}/tasks/${taskId}`,
  taskProgressPings: (taskId = ":taskId") =>
    `/${rootPaths.olitaskRoot}/tasks/${taskId}/progress-pings`,
  reviewsTaskReviews: (taskId = ":taskId") =>
    `/${rootPaths.olitaskRoot}/reviews/task/${taskId}`,
  taskCategories: `/${rootPaths.olitaskRoot}/tasks/categories`,
  taskCounterOffers: (taskId = ":taskId") =>
    `/${rootPaths.olitaskRoot}/tasks/${taskId}/counter-offers`,

  //donation paths
  donationsDashboard: `/${rootPaths.olitaskRoot}/donations/summary`,
  donationsList: `/${rootPaths.olitaskRoot}/donations/list`,
  guestDonations: `/${rootPaths.olitaskRoot}/donations/guest`,
  donationDetails: (donationId) =>
    `/${rootPaths.olitaskRoot}/donations/${
      donationId ? `${donationId}` : ":donationId"
    }`,
  donationsCredit: `/${rootPaths.olitaskRoot}/donations/credits`,
  creditDetails: (creditId) =>
    `/${rootPaths.olitaskRoot}/credits/${
      creditId ? `${creditId}` : ":creditId"
    }`,
  issueCredit: (donationId) =>
    `/${rootPaths.olitaskRoot}/donations/${
      donationId ? `${donationId}` : ":donationId"
    }/issue-credit`,
  donationsDonors: `/${rootPaths.olitaskRoot}/donations/donors`,
  donorDonations: (donorId) =>
    `/${rootPaths.olitaskRoot}/donations/donor/${
      donorId ? `${donorId}` : ":donorId"
    }`,
  donationsPurposes: `/${rootPaths.olitaskRoot}/donations/purposes`,
  creditApplications: `/${rootPaths.olitaskRoot}/donations/credit-applications`,
  applicationDetails: (applicationId) =>
    `/${rootPaths.olitaskRoot}/donations/credit-applications/${
      applicationId ? `${applicationId}` : ":applicationId"
    }`,
  issueCreditFromApplication: (applicationId) =>
    `/${rootPaths.olitaskRoot}/donations/credit-application/${
      applicationId ? `${applicationId}` : ":applicationId"
    }/issue-credit`,

  userAdd: `/${rootPaths.olitaskRoot}/users/add`,
  userEdit: (userId = ":userId") =>
    `/${rootPaths.olitaskRoot}/users/${userId}/edit`,
  feedBacks: `/${rootPaths.olitaskRoot}/feedbacks`,
  appVersions: `/${rootPaths.olitaskRoot}/app-versions`,
  subscriptions: `/${rootPaths.olitaskRoot}/subscriptions`,
  qaTestRuns: `/${rootPaths.olitaskRoot}/qa-test-runs`,
  qaTestRunsFeatures: (appId = ":appId") =>
    `/${rootPaths.olitaskRoot}/qa-test-runs/${appId}/features`,
  qaTestRunsAppHistory: (appId = ":appId") =>
    `/${rootPaths.olitaskRoot}/qa-test-runs/${appId}/history`,
  qaTestRunsFeatureHistory: (appId = ":appId", featureId = ":featureId") =>
    `/${rootPaths.olitaskRoot}/qa-test-runs/${appId}/features/${featureId}/history`,
  qaTestRunsChecklist: (appId = ":appId") =>
    `/${rootPaths.olitaskRoot}/qa-test-runs/${appId}/checklist`,
  cancellationPolicyRules: `/${rootPaths.olitaskRoot}/cancellation-policy-rules`,
  cancellationPolicyActive: `/${rootPaths.olitaskRoot}/cancellation-policy-rules/active`,
  cancellationPolicyHistory: `/${rootPaths.olitaskRoot}/cancellation-policy-rules/history`,

  helpRequests: `/${rootPaths.olitaskRoot}/help-requests`,

  roles: `/${rootPaths.accessControlRoot}/roles`,
  roleDetails: (roleId) =>
    `/${rootPaths.accessControlRoot}/roles/${roleId ? `${roleId}` : ":roleId"}`,
  privileges: `/${rootPaths.accessControlRoot}/privileges`,
  assignRole: `/${rootPaths.accessControlRoot}/assign-role`,
  apiKeys: `/${rootPaths.accessControlRoot}/api-keys`,
  clientIds: `/${rootPaths.accessControlRoot}/client-Ids`,
  rateLimitEvents: `/${rootPaths.accessControlRoot}/rate-limit-events`,
  appConfig: `/${rootPaths.accessControlRoot}/app-config`,
  clientIdDetails: (clientId = ":clientId") =>
    `/${rootPaths.accessControlRoot}/client-Ids/${clientId}`,
  clientIdEdit: (clientId = ":clientId") =>
    `/${rootPaths.accessControlRoot}/client-Ids/${clientId}/edit`,
  routeRules: `/${rootPaths.accessControlRoot}/route-auth-rules`,
  manageApps: `/${rootPaths.accessControlRoot}/apps`,
  locationRestrictions: `/${rootPaths.accessControlRoot}/location-restrictions`,

  // project management paths
  projects: `/${rootPaths.generalRoot}/projects`,
  projectAdd: `/${rootPaths.generalRoot}/projects/add`,
  projectDetails: (projectId = ":projectId") =>
    `/${rootPaths.generalRoot}/projects/${projectId}`,
  projectEdit: (projectId = ":projectId") =>
    `/${rootPaths.generalRoot}/projects/${projectId}/edit`,
  projectIterations: (projectId = ":projectId") =>
    `/${rootPaths.generalRoot}/projects/${projectId}/iterations`,
  projectIterationAdd: (projectId = ":projectId") =>
    `/${rootPaths.generalRoot}/projects/${projectId}/iterations/add`,
  projectIterationDetails: (
    projectId = ":projectId",
    iterationId = ":iterationId",
  ) =>
    `/${rootPaths.generalRoot}/projects/${projectId}/iterations/${iterationId}`,
  projectIterationEdit: (
    projectId = ":projectId",
    iterationId = ":iterationId",
  ) =>
    `/${rootPaths.generalRoot}/projects/${projectId}/iterations/${iterationId}/edit`,
  projectTasks: (projectId = ":projectId", iterationId = ":iterationId") =>
    `/${rootPaths.generalRoot}/projects/${projectId}/iterations/${iterationId}/tasks`,
  projectTaskDetails: (
    projectId = ":projectId",
    iterationId = ":iterationId",
    taskId = ":taskId",
  ) =>
    `/${rootPaths.generalRoot}/projects/${projectId}/iterations/${iterationId}/tasks/${taskId}`,
  projectTaskAdd: (projectId = ":projectId", iterationId = ":iterationId") =>
    `/${rootPaths.generalRoot}/projects/${projectId}/iterations/${iterationId}/tasks/add`,
  projectTaskEdit: (
    projectId = ":projectId",
    iterationId = ":iterationId",
    taskId = ":taskId",
  ) =>
    `/${rootPaths.generalRoot}/projects/${projectId}/iterations/${iterationId}/tasks/${taskId}/edit`,
  Tags: `/${rootPaths.generalRoot}/tags`,
  pmDashboard: `/${rootPaths.generalRoot}/pm-dashboard`,

  // finance
  paymentCharges: `/${rootPaths.financeRoot}/payment-charges`,
  paymentTransactions: `/${rootPaths.financeRoot}/payment-transactions`,
  paymentRefundHistory: (transactionId = ":transactionId") =>
    `/${rootPaths.financeRoot}/payment-transactions/${transactionId}/refunds`,
  externalAccounts: `/${rootPaths.financeRoot}/payments/external/accounts`,
  payouts: `/${rootPaths.financeRoot}/payout-transactions`,
  payoutCharges: `/${rootPaths.financeRoot}/payout-charges`,

  // profile (business module)
  businessEntities: `/${rootPaths.profileRoot}/business-entities`,
  businessEntityDetails: (businessEntityId = ":businessEntityId") =>
    `/${rootPaths.profileRoot}/business-entities/${businessEntityId}`,
  serviceOfferings: `/${rootPaths.profileRoot}/service-offerings`,
  attachServiceOffering: (serviceCode = ":serviceCode") =>
    `/${rootPaths.profileRoot}/service-offerings/attach/${serviceCode}`,
};
